import Api from "../Utils/Axios";

export const GetSubscriptionReports = async (params = {}) => {
  const response = await Api.get("subscription/reports", { params });
  return response.data;
};

export const GetSubscriptionUsers = async (params = {}) => {
  const response = await Api.get("subscription/users", { params });
  return response.data;
};

export const GetClientUserAutocomplete = async (params = {}) => {
  const response = await Api.get("clientUser/autocomplete", { params });
  return response.data;
};


